const initialState = {
  favorites: [],
  status: {
    scriptId: null,
    error: false,
    loading: false,
    success: false,
  },
}

const favoriteScripts = (state = initialState, action) => {
  switch (action.type) {
    case 'FAVORITE_SCRIPT':
      state = {
        ...state,
        status: {
          scriptId: action?.payload?.scriptId,
          error: false,
          loading: true,
          success: false,
        },
      }
      break
    case 'FAVORITED_SCRIPT':
      state = {
        ...state,
        favorites: action?.payload?.favoriteScript,
        status: {
          scriptId: action?.payload?.scriptId,
          error: false,
          loading: false,
          success: true,
        },
      }
      break
    case 'FAVORITE_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialState,
            error: true,
            message: action?.payload?.message,
          },
        }
      }
    default:
      // do nothing
      break
  }
  return state
}

export default favoriteScripts
